module.exports = __webpack_public_path__ + "static/img/pay-3.d4cb718.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay/pay-3.png
// module id = V78j
// module chunks = 1